import React, { useEffect } from "react";
import { observer } from "mobx-react";
import "primeflex/primeflex.css";
import { UniversalUploadViewModel } from "./UniversalUploadViewModel";
import Utils from "../../infrastructure/Utils";
import "./UniversalUploadView.css";
import UserContext from "../../infrastructure/UserContext";
import { respondToAuthCacheRequest } from "../../infrastructure/authCacheRelay";
import { getToken } from "../../infrastructure/Auth0Authenticator";

// Plain function component, deliberately NOT wrapped in observer(): this
// codebase's mobx-react@5 wraps observer() function components as class
// components under the hood, and hooks can't run inside a class component's
// render() (see MarketersView.tsx's MarketersAuthRelay for the same trap).
const UniversalUploadAuthRelay: React.FC<{ documentUploaderBaseUrl: string }> = ({
  documentUploaderBaseUrl,
}) => {
  useEffect(() => {

    // Warm this token now, before the iframe's REQUEST_AUTH_CACHE arrives.
    // getToken() serializes through acquireToken()'s Web Lock, which is also
    // queued behind every other API call this page fires on load - asking
    // for it lazily inside respondToAuthCacheRequest means it can lose the
    // child's cold-load timeout race.
    getToken().catch(() => {});

    const handleMessage = (event: MessageEvent) => {

      if (event.origin !== documentUploaderBaseUrl) return;
      respondToAuthCacheRequest(event, documentUploaderBaseUrl);
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [documentUploaderBaseUrl]);

  return null;
};

export const UniversalUploadView: React.FC<{
  vm: UniversalUploadViewModel;
}> = observer((props) => {
  let env = Utils.getAppHostKey();
  let documentUploaderUrl =
    `https://documentuploader-${env}.integrityconnect.com/app?tenantName=${Utils.getBUName()}&connectUserId=${UserContext.getUserId()}`
      .replace("-prod", "");
  // let documentUploaderUrl = `http://localhost:3003/app`; // enable only for local development
  const documentUploaderBaseUrl = new URL(documentUploaderUrl).origin;

  return (
    <>
        <div className="uu-container">
          <UniversalUploadAuthRelay documentUploaderBaseUrl={documentUploaderBaseUrl} />
          <iframe src={`${documentUploaderUrl}`} id="bob-iframe" frameBorder="0" />
        </div>
    </>
  );
});
